import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { useLocaleContext } from '@src/components/locale/locale.context'
import { useStatsigDynamicHolidayConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-holiday-config.hook'
import useEddExp from '@src/quince-site-common/src/hooks/edd/hooks/useEddExp'
import { generateEDDLabel } from '@src/quince-site-common/src/hooks/edd/utils/edd.utils'
import { EDDDetails } from '@src/quince-site-common/src/services/eddService/eddService.types'

import styles from './product-card-footer.module.scss'

interface ClpTag {
  textColor: string
  backgroundColor: string
  message?: Record<string, string>
}

export function BottomTagComponent({
  isWhiteGloveDelivery,
  eddDetails,
  isPageEligibleForHolidayTag,
}: {
  isWhiteGloveDelivery?: boolean
  eddDetails?: EDDDetails
  isPageEligibleForHolidayTag?: boolean
}) {
  const { t: tCommon } = useTranslation('common')
  const { locale } = useLocaleContext()
  const holidayConfig = useStatsigDynamicHolidayConfig()
  const eddLabel = generateEDDLabel(eddDetails, tCommon)
  const { isEddExpEnabled: isEDDExpEnabled } = useEddExp()

  // Get all holiday messages for CLP tags if displayTags exists
  const holidayClpTags: { message: string; textColor: string; backgroundColor: string }[] = []
  if (
    isPageEligibleForHolidayTag &&
    eddDetails?.displayTags &&
    Array.isArray(eddDetails.displayTags) &&
    eddDetails.displayTags.length > 0 &&
    holidayConfig?.tags
  ) {
    // Find all matching enabled tags from displayTags array
    eddDetails.displayTags.forEach(displayTag => {
      const tagConfig = holidayConfig.tags.find(tag => tag.tag === displayTag && tag.enabled)

      // Based on actual config, clpTags is a direct object with textColor, backgroundColor, and message
      if (tagConfig?.clpTags) {
        // Handle clpTags as direct object (matches actual config structure)
        const clpTag = tagConfig.clpTags as ClpTag

        // Get message for current locale, fallback to first available
        const clpMessage =
          clpTag.message?.[locale] ?? (clpTag.message ? Object.values(clpTag.message)[0] : null) ?? null
        if (clpMessage) {
          holidayClpTags.push({
            message: clpMessage,
            textColor: clpTag.textColor,
            backgroundColor: clpTag.backgroundColor,
          })
        }
      }
    })
  }

  return (
    <>
      {eddLabel && isEDDExpEnabled && <div className={classNames(styles.bottomTag, styles.eddLabel)}>{eddLabel}</div>}
      {holidayClpTags.length > 0 &&
        holidayClpTags.map((clpTag, index) => (
          <div
            key={index}
            className={styles.whiteglove}
            style={{
              color: clpTag.textColor,
              backgroundColor: clpTag.backgroundColor,
            }}
          >
            {clpTag.message}
          </div>
        ))}
      {isWhiteGloveDelivery ? <div className={styles.whiteglove}>{tCommon('free_white_glove_delivery')}</div> : null}
    </>
  )
}
